import { render, staticRenderFns } from "./HotelBasicInfo.vue?vue&type=template&id=01b19136&scoped=true"
import script from "./HotelBasicInfo.vue?vue&type=script&lang=js"
export * from "./HotelBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./HotelBasicInfo.vue?vue&type=style&index=0&id=01b19136&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b19136",
  null
  
)

export default component.exports